var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#042b62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7087992,27.4175983 C21.2687987,27.4175983 27.4175983,21.2687987 27.4175983,13.7087992 C27.4175983,6.14879962 21.2687987,0 13.7087992,0 C6.14879962,0 0,6.14879962 0,13.7087992 C0,21.2687987 6.14879962,27.4175983 13.7087992,27.4175983 Z M13.7087992,1.10879993 C20.6583987,1.10879993 26.3087984,6.75919958 26.3087984,13.7087992 C26.3087984,20.6583987 20.6583987,26.3087984 13.7087992,26.3087984 C6.75919958,26.3087984 1.10879993,20.6583987 1.10879993,13.7087992 C1.10879993,6.75919958 6.75919958,1.10879993 13.7087992,1.10879993 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7599993,18.2615989 C11.8663993,18.3679989 12.0119993,18.4239989 12.1519992,18.4239989 C12.2919992,18.4239989 12.4375992,18.3679989 12.5439992,18.2615989 L16.704799,14.1007991 C16.811199,13.9943991 16.867199,13.8543991 16.867199,13.7087992 C16.867199,13.5631992 16.811199,13.4231992 16.704799,13.3167992 L12.5439992,9.15599943 C12.3255992,8.93759945 11.9783993,8.93759945 11.7599993,9.15599943 C11.5415993,9.37439942 11.5415993,9.7215994 11.7599993,9.93999939 L15.528799,13.7087992 L11.7599993,17.4775989 C11.5471993,17.6959989 11.5471993,18.0487989 11.7599993,18.2615989 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow-next.ce90fce3b4e7b7766aa07cbce47ae802.svg";
export { ForwardRef as ReactComponent };